<mj-page-layout>
    @switch (view) {
        @case ('profile') {
            <mj-page-body>
                @if (recordID) {
                    <ra-person-detail [ContributorID]="recordID" [Recommended]="DetailIsRecommended" [IsNew]="DetailIsNew" [Overlaps]="DetailOverlaps" (SeeSimilar)="OnSeeSimilar()" (BackToHome)="OnBackToHome()" />
                } @else {
                    <!-- No record named: the gone-listing panel (P/proto-states.js:121). -->
                    <agu-state-panel [Icon]="GoneCopy.Icon" [Title]="GoneCopy.Title" [Body]="GoneCopy.Body" PrimaryLabel="See similar" SecondaryLabel="Back to Home" (Primary)="OnSeeSimilar()" (Secondary)="OnBackToHome()" />
                }
            </mj-page-body>
        }
        @default {
            <mj-page-body>
              @if (Lapsed) {
                <agu-state-panel Variant="lock" [Icon]="LockCopy.Icon" [Title]="LockCopy.Title" [Body]="LockCopy.Body" PrimaryLabel="Renew membership" SecondaryLabel="Compare membership options" (Primary)="OnRenew()" (Secondary)="OnRenew()" />
              } @else {
                <!-- Hero copy as P/people-finder.html:1208-1210 (PD §2.3). -->
                <agu-page-band
                    Eyebrow="People"
                    Title="People Finder"
                    Sub="Paste an abstract, session description, or research topic to find researchers whose work complements yours, or open Recommended to start with the people we've already matched to your profile."
                    [Accent]="Accent"
                />

                <agu-search-hero
                    Eyebrow="Search people"
                    Placeholder="Describe who you're looking for, search by name or institution, or paste an abstract or project summary."
                    SubmitLabel="Search"
                    BusyLabel="Searching…"
                    AttachLabel="Attach a document"
                    AttachHint="PDF, DOCX or TXT"
                    [Accent]="Accent"
                    [Attachment]="attachment"
                    [Suggestions]="TryChips"
                    [Busy]="loading"
                    [Query]="state.query"
                    (QueryChange)="OnQueryChange($event)"
                    (Submitted)="OnSubmitted($event)"
                    (FileSelected)="OnFileSelected($event)"
                    (AttachmentRemoved)="OnAttachmentRemoved()"
                    (SuggestionSelected)="OnSuggestionSelected($event)"
                />
                <!-- The landing strip (P/Member_Hub.html:1383-1401): landing state only; fades back in when results give way. -->
                @if (HeroStrip; as ad) { <agu-ad-slot [Placement]="ad" [Reveal]="RevealStamp > 0" /> }

                <agu-tab-strip
                    class="ra-viewtabs"
                    [Tabs]="Tabs"
                    [Active]="state.tab"
                    [PanelId]="ResultsPanelId"
                    (ActiveChange)="OnTabChange($event)"
                />
                <!-- One caption per tab, verbatim from the mockup's VIEWNOTE (collaborators.html:947-950); the <b> takes the module accent. -->
                @if (state.tab === 'recommended') {
                    <p class="ra-viewnote" aguFade>Matched on your <b>ORCID</b> record and <b>AGU</b> co-author network.</p>
                    <!-- The filter rail is not rendered on this tab (P-G11/P-C9), so the co-author switch sits with the caption. -->
                    <div class="ra-hidecoauthors">
                        <mj-switch OnLabel="Hide co-authors" OffLabel="Hide co-authors" [ngModel]="hideCoauthors" (ngModelChange)="OnHideCoauthorsChange($event)" />
                    </div>
                } @else {
                    <p class="ra-viewnote" aguFade>Every researcher in the AGU directory, filter by mutual co-authors, area or institution.</p>
                }

                <div class="ra-resultwrap" [class.ra-resultwrap--full]="state.tab !== 'all'">
                    <!-- On a phone the rail is projected into the bottom filter sheet (P/Member_Hub.html:603-620, 896-911); one template, two hosts. -->
                    @if (state.tab === 'all') {
                        @if (Phone.IsPhone) {
                            <agu-filter-sheet [Open]="Phone.FiltersOpen" [ScrollToGroup]="Phone.FilterGroup" (Closed)="Phone.CloseFilters()" (ShowResults)="Phone.CloseFilters()">
                                <ng-container *ngTemplateOutlet="filterRail" />
                            </agu-filter-sheet>
                        } @else {
                            <ng-container *ngTemplateOutlet="filterRail" />
                        }
                    }
                    <ng-template #filterRail>
                        <agu-filter-rail [ActiveCount]="ActiveFilterCount" (ClearAll)="OnClearFilters()">
                            <ra-people-filters
                                [Filters]="state.filters"
                                (FiltersChange)="OnFiltersChange($event)"
                                [Facets]="facets"
                                [ShowSavedOnly]="showSavedOnly"
                                (ShowSavedOnlyChange)="showSavedOnly = $event"
                                [RecommendedOnly]="state.filters.recommendedOnly === true"
                                (RecommendedOnlyChange)="OnRecommendedOnlyChange($event)"
                            />
                        </agu-filter-rail>
                    </ng-template>

                    <div class="ra-resultcol">
                        <!-- The mockup's Recommended section holds only its grid (and pinned section): no sort chip, no filter pills (P-G11/P-C9/P-J8). -->
                        @if (state.tab === 'all') {
                            <!-- The phone's quick-filter row: Filters [count], the sort, the first four groups (P/Member_Hub.html:915-951). -->
                            @if (Phone.IsPhone) {
                                <agu-mobile-chips
                                    [FilterCount]="ActiveFilterCount"
                                    [SortOptions]="PhoneSortOptions"
                                    [Sort]="state.sort"
                                    [Groups]="FilterGroups"
                                    [ActiveGroups]="ActiveFilterGroups"
                                    (OpenFilters)="Phone.OpenFilters($event)"
                                    (SortChange)="OnSortChange($event)"
                                />
                            }
                            <ra-finder-toolbar
                                [Sort]="state.sort"
                                [SortOptions]="SortOptions"
                                [Count]="ResultCount"
                                (SortChange)="OnSortChange($event)"
                            />
                            <ra-active-pills [Pills]="FilterPills" (Remove)="OnRemoveFilterGroup($event)" />
                        }

                        <div class="ra-finder__results" [id]="ResultsPanelId" role="tabpanel"
                [aguReveal]="RevealDirectionValue" [RevealKey]="RevealStamp" RevealItems=":scope .ra-grid > *, :scope .ra-list > *">
                            @if (state.tab === 'recommended' && PinnedItems.length > 0) {
                                <section class="ra-finder__section" aria-labelledby="ra-people-pinned-h">
                                    <h3 id="ra-people-pinned-h">Pinned by you</h3>
                                    <div class="ra-grid ra-grid--people">
                                        @for (item of PinnedItems; track item.contributorID) {
                                            <ra-person-card
                                                [aguRise]="$index" [RiseDistance]="6" [RiseKey]="RiseStamp"
                                                [Person]="item"
                                                [Recommended]="IsRecommendation(item)"
                                                [ShowPin]="true"
                                                (Save)="OnSave(item, $event)"
                                                (Pin)="OnPin(item, $event)"
                                                (Dismiss)="OnDismiss(item)"
                                                (Open)="OnOpen(item)"
                                            />
                                        }
                                    </div>
                                </section>
                            }

                            <!-- Product states (PD §5; P/proto-states.js:97-98, 115, 129): 4 skeleton cards, the error panel, the empties. -->
                            @if (loading) {
                                <agu-skeleton [Count]="4" />
                            } @else if (error) {
                                <agu-state-panel
                                    Variant="error"
                                    [Icon]="ErrorCopy.Icon"
                                    [Title]="ErrorCopy.Title"
                                    [Body]="ErrorCopy.Body"
                                    PrimaryLabel="Try again"
                                    [SecondaryLabel]="failures.SupportHref ? 'Contact support' : null"
                                    [SecondaryHref]="failures.SupportHref"
                                    [Foot]="failures.Foot"
                                    [Note]="failures.Note"
                                    (Primary)="Retry()"
                                />
                            } @else if (IsPreSearch) {
                                <agu-state-panel
                                    Icon="search"
                                    Title="Find people to get started"
                                    Body="Paste an abstract, describe a topic, try one of the suggestions above, or open Recommended for people matched to your profile."
                                />
                            } @else if (ShowNothingToMatchYet) {
                                <agu-state-panel
                                    Icon="spark"
                                    Title="Nothing to match yet"
                                    Body="Recommendations use your AGU co-author network and publication record. Search with a few sentences about your work, or upload a CV in Career Explorer."
                                />
                            } @else if (IsEmpty) {
                                @if (IsUnrecognized) {
                                    <agu-state-panel
                                        Icon="search"
                                        Title="We couldn't understand that search."
                                        Body="Try a research topic, institution or area — for example “Gulf Coast hydrologists”."
                                    />
                                } @else if (state.tab === 'recommended') {
                                    <agu-state-panel
                                        [Icon]="RecommendedEmptyCopy.Icon"
                                        [Title]="RecommendedEmptyCopy.Title"
                                        [Body]="RecommendedEmptyCopy.Body"
                                        [PrimaryLabel]="BrowseAll"
                                        SecondaryLabel="Widen research areas"
                                        (Primary)="SetTab('all')"
                                        (Secondary)="OnWidenResearchAreas()"
                                    />
                                } @else {
                                    <agu-state-panel
                                        [Icon]="AllEmptyCopy.Icon"
                                        [Title]="AllEmptyCopy.Title"
                                        [Body]="AllEmptyCopy.Body"
                                        SecondaryLabel="Widen research areas"
                                        (Secondary)="OnWidenResearchAreas()"
                                    />
                                }
                                <!-- The Circles line inside the no-results panel (P/Member_Hub.html:1611-1612). -->
                                @if (NoResultsLine; as ad) { <agu-ad-slot [Placement]="ad" /> }
                            } @else {
                                <div class="ra-grid ra-grid--people">
                                    @for (item of DisplayItems; track item.contributorID) {
                                        <ra-person-card
                                            [aguRise]="$index" [RiseDistance]="6" [RiseKey]="RiseStamp"
                                            [Person]="item"
                                            [Recommended]="state.tab === 'recommended'"
                                            [ShowPin]="true"
                                            (Save)="OnSave(item, $event)"
                                            (Pin)="OnPin(item, $event)"
                                            (Dismiss)="OnDismiss(item)"
                                            (Open)="OnOpen(item)"
                                        />
                                    }
                                </div>

                                @if (state.tab === 'all') {
                                    <agu-pagination [Page]="state.page" [PageSize]="state.pageSize" [Total]="total" (PageChange)="OnPageChange($event)" />
                                }
                            }

                            <!-- Matches the Collaborators mockup: the "all" tab's pagerbar keeps the
                                 footnote visible alongside the pager even in the zero-results state
                                 (unlike the pager itself, which only makes sense once Total > 0). -->
                            @if (!loading && state.tab === 'all') {
                                <p class="ra-finder__footnote">*Ranked by relevance of published works and abstracts, and recent research activity.</p>
                            }
                        </div>

                        @if (LastDismissed$ | async; as dismissed) {
                            <mj-alert aguFade Variant="info" Size="sm" Role="status">
                                Hidden: <b>{{ dismissed.title }}</b>
                                <button type="button" mjButton variant="flat" class="agu-hit-24" actions (click)="Undo()">Undo</button>
                            </mj-alert>
                        }
                    </div>
                </div>

                <!-- The Circles row, after the recommended grid or the results (P/Member_Hub.html:1586-1610). -->
                @if (!loading && Circles; as ad) { <agu-ad-slot [Placement]="ad" /> }
              }
            </mj-page-body>
        }
    }
</mj-page-layout>
